window.onload = function () {

  var people = document.getElementById("people-count");
  var stock = document.getElementById("stock-count");

  if (people) {
    people.textContent = Math.floor(Math.random() * 31) + 18;
  }

  if (stock) {
    stock.textContent = Math.floor(Math.random() * 7) + 3;
  }

};